import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomersUtil } from "../../../utility";
const useCustomers = () => {
  const dispatch = useDispatch()
  const { all_customers } = useSelector(state => state.orders)
  const [customers, setCustomers] = useState([])
  const [type, setType] = useState('company')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(50)
  const [searchValue, setSearchValue] = useState("");
  const [canSearch, setCanSearch] = useState(false);
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [totalPages, setTotalPages] = useState(0)
  const toggleCreateCustomer = () => setModal(!modal);
  const gettingCustomers = () => {

    fetchCustomersUtil({
      page,
      search: searchValue ?? "",
      pageSize,
      type,
      setLoading,
      dispatch,
      setTotalPages,
    });
  }
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      gettingCustomers()
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [page, searchValue, type, pageSize]);
  useEffect(() => {
    let search = localStorage.getItem('customerSearch') ?? ""
    const storedPage = parseInt(localStorage.getItem("customerPage"), 10) || 1;
    setSearchValue(search)
    setPage(storedPage)
  }, [])
  useEffect(() => {
    setCustomers(all_customers ?? [])
  }, [all_customers])
  return {
    modal,
    setModal,
    toggleCreateCustomer,
    customers,
    searchValue,
    setSearchValue,
    canSearch,
    setCanSearch,
    selectedData,
    setSelectedData,
    data,
    setData,
    page, setPage, pageSize, setPageSize, loading, totalPages, type, setType, gettingCustomers
  };
};
export default useCustomers;
